<template>
  <DKitSupportPanel
    v-model="model"
    :api-token="AuthService.fullAccessToken"
    app-id="deepsign"
    :chat-api-token="apiToken"
    :env="env"
    :user="AuthService.user"
  />
</template>

<script setup lang="ts">
import { DKitSupportPanel } from '@deepcloud/deep-ui-kit';
import AuthService from '@/services/authService.ts';

const model = defineModel({
  type: Boolean,
  default: false
});

const apiToken = import.meta.env.VITE_APP_DEEP_CHAT_API_KEY;
const env = import.meta.env.VITE_ENVIRONMENT;
</script>
